<div class="my-1 mx-3 wineryCard cursor-pointer">
    <p-card [style]="{height: '100%'}">
      <ng-template pTemplate="header">
        <div class="headCard flex justify-content-between"
            [style.backgroundImage]="'url(https://res.cloudinary.com/divinea/image/upload/c_fill,h_530,w_772/v1/production/store/e2cc135a34233d870f56ce8ef6d8af8a.jpg)'">
        </div>
    </ng-template>
    
     <div class="detailWinery my-2 mx-3 flex gap-5 justify-content-start align-items-center">
      <div class="imageLogo" style="background-image: url(&quot;https://res.cloudinary.com/divinea/image/upload/c_fill,h_150,w_150/v1/production/cache/wadqltjlrg3dxdnhqj7x.jpg&quot;); background-position: center center;">
      </div>
      <div>
        <p class="font-bold text-lg">
        {{wineryCompany?.name}}
      </p>
      </div>
     </div>
  
    </p-card>
  </div>